module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_9006.894b7762.png";